<template>
  <div class="simple-card-map" :style="{ left: adjustedPosition.x + 'px', top: adjustedPosition.y + 'px' }" @click="redirectToLodging" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
    <div class="simple-card-inner">
      <div class="simple-card-img-wrapper">
        <img class="simple-card-img" :src="formatSource()" :alt="lodging.name">
      </div>
      <div class="simple-card-content">
        <div class="simple-card-header">
          <h3 class="simple-card-title no-translate">{{ lodging.name }}</h3>
          <button class="simple-card-close desktop-only" @click.stop="$emit('card-hover', false)">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="#333" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
        
        <p class="raleway-reg-p13 mb-1">À partir de <strong>{{ lodging.lowest_price }}€/nuit</strong></p>
        <p class="merriweather-italic lodging-type mb-3">
          {{ typeLabels[lodging.type] || "Lodges et lieux insolites" }} - 
          {{ lodging.is_entire ? lodging.rooms_count : 1 }} 
          {{ lodging.is_entire ? lodging.rooms_count > 1 ? 'chambres' : 'chambre' : 'chambre' }}
        </p>
        
        <button class="simple-card-btn desktop-only" @click.stop="redirectToLodging">VOIR LES TARIFS</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimpleCardmap',
  props: ['lodging', 'position'],
  data() {
    return {
      typeLabels: {
        Hotel: "Hôtels",
        "Maison et Villa": "Maisons et Villas",
        Guestroom: "Chambres d'Hôtes",
        Lodge: "Lodges et Lieux Insolites",
        Appartment: "Appartements",
        Chalet: "Chalets"
      }
    }
  },
  computed: {
    adjustedPosition() {
      if (!this.position) return { x: 0, y: 0 };
      
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      const padding = 10; // Padding from viewport edges
      
      const isDesktop = viewportWidth >= 768;
      const currentWidth = isDesktop ? 380 : 250;
      const currentHeight = isDesktop ? 200 : 160;
      
      let adjustedX = this.position.x;
      let adjustedY = this.position.y;
      
      // Calculate the card's boundaries with transform: translateX(-50%)
      const cardLeftEdge = adjustedX - (currentWidth / 2);
      const cardRightEdge = adjustedX + (currentWidth / 2);
      
      // Adjust horizontal position if card goes outside viewport
      if (cardLeftEdge < padding) {
        // Card is cut off on the left, move it right
        adjustedX = (currentWidth / 2) + padding;
      } else if (cardRightEdge > (viewportWidth - padding)) {
        // Card is cut off on the right, move it left
        adjustedX = viewportWidth - (currentWidth / 2) - padding;
      }
      
      // Adjust vertical position if card goes outside viewport
      if (adjustedY < padding) {
        // Card is cut off at the top
        adjustedY = padding;
      } else if (adjustedY + currentHeight > (viewportHeight - padding)) {
        // Card is cut off at the bottom
        adjustedY = viewportHeight - currentHeight - padding;
      }
      
      return { x: adjustedX, y: adjustedY };
    }
  },
  methods: {
    formatSource() {
      if (this.lodging.photo_banner) {
        return this.lodging.photo_banner
      } else {
        return 'https://media.gettyimages.com/photos/bedroom-in-new-luxury-home-picture-id1194686012?k=6&m=1194686012&s=612x612&w=0&h=IX6Bjhwa5M5NtCtlKll-FFi_hn5lxrPwiUImH3fsZZ0=';
      }
    },
    redirectToLodging() {
      window.open(`/reservation-hotel/${this.lodging.slug}`, '_blank');
    },
    onMouseEnter() {
      this.$emit('card-hover', true);
    },
    onMouseLeave() {
      this.$emit('card-hover', false);
    }
  }
}
</script>

<style lang="scss" scoped>
.simple-card-map {
  position: fixed;
  background: white;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1001;
  pointer-events: auto;
  transform: translateX(-50%);
  cursor: pointer;

  /* Desktop styling */
  @media (min-width: 768px) {
    width: 380px;
  }

  /* Mobile styling */
  @media (max-width: 767px) {
    width: 250px;
    overflow: hidden;
  }
}

.simple-card-inner {
  display: flex;
  
  @media (min-width: 768px) {
    flex-direction: row;
    height: 200px;
  }
  
  @media (max-width: 767px) {
    flex-direction: column;
  }
}

.simple-card-img-wrapper {
  @media (min-width: 768px) {
    flex: 0 0 45%;
    max-width: 45%;
    height: 100%;
  }
  
  @media (max-width: 767px) {
    width: 100%;
    height: 120px;
  }
}

.simple-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  
  @media (min-width: 768px) {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
}

.simple-card-content {
  padding: 12px;
  
  @media (min-width: 768px) {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 16px;
  }
}

.simple-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 4px;
}

.simple-card-title {
  font-size: 14px;
  font-weight: bold;
  margin: 0;
  color: #333;
  line-height: 1.2;
}

.simple-card-close {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  
  @media (max-width: 767px) {
    display: none;
  }
}

.desktop-only {
  @media (max-width: 767px) {
    display: none !important;
  }
}

.mobile-only {
  @media (min-width: 768px) {
    display: none !important;
  }
}

.simple-card-address {
  margin-bottom: 10px;
}

.simple-card-btn {
  background-color: #3B6152;
  color: white;
  border: none;
  padding: 10px;
  text-align: center;
  font-size: 14px;
  font-family: inherit;
  border-radius: 2px;
  cursor: pointer;
  width: 100%;
  transition: opacity 0.2s;
  margin-top: auto;
  
  &:hover {
    opacity: 0.9;
  }
}

.lodging-type {
  font-size: 12px;
  color: grey;
}
</style>